import { resolveHTTP } from '@/services/api'

const Api = resolveHTTP('/bl/bank-accounts')

Api.exportRoute = () => {
  return Api.apiURl + Api.relativeUrl + '/xlsx'
}

export default Api



// WEBPACK FOOTER //
// ./src/services/api/bl-bankaccounts.js